import Questions from "./Questions.jsx";

export default Questions;
